import { clubfinderCdnApi } from "@/utils/axios.utils";
import { ISportaanbiederLocatie } from "./sportaanbieder.repository";

class LocatieRepository {
        async getLocatie(id: string) {
            const response = await clubfinderCdnApi.get<ISportaanbiederLocatie>('/api/locatie/getlocatie', {
                params: {
                    id: id
                }
            });
            return response.data;
        }
}

export default new LocatieRepository();